import _implicitStylesheets from "./iconInteractive.css";
import _implicitScopedStylesheets from "./iconInteractive.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _axButton from "ax/button";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "ax-icon-interactive": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element} = $api;
  return [api_custom_element("ax-button", _axButton, {
    className: api_normalize_class_name($cmp.classes),
    props: {
      "href": $cmp.href,
      "variant": "tertiary",
      "size": $cmp.size,
      "disabled": $cmp.disabled,
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "type": $cmp.type,
      "form": $cmp.form
    },
    key: 0
  }, [api_custom_element("ax-icon", _axIcon, {
    slotAssignment: "start",
    classMap: stc0,
    props: {
      "iconDescription": $cmp.iconDescription,
      "ariaHidden": $cmp.ariaHidden,
      "icon": $cmp.icon
    },
    key: 1
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-39s0u29drab";
tmpl.legacyStylesheetToken = "ax-iconInteractive_iconInteractive";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
